import React, { useState, useEffect } from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import DonationEntry from './components/DonationEntry';
import DonorProfile from './components/DonorProfile';
import ReportGenerator from './components/ReportGenerator';
import Navigation from './components/Navigation';
import { DonationProvider } from './context/DonationContext';
import './App.css';

function App() {
  const [currentStep, setCurrentStep] = useState('donor');

  return (
    <DonationProvider>
      <Router>
        <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
          <div className="max-w-4xl mx-auto px-4 py-6">
            <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
              <div className="bg-gradient-to-r from-blue-600 to-indigo-600 p-6">
                <h1 className="text-2xl font-bold text-white mb-2">
                  Donation Receipt Exporter
                </h1>
                <p className="text-blue-100 text-sm">
                  Professional FMV calculation for charitable donations
                </p>
              </div>

              <Navigation currentStep={currentStep} setCurrentStep={setCurrentStep} />

              <div className="p-6">
                <Routes>
                  <Route path="/" element={<Navigate to="/donor" replace />} />
                  <Route path="/donor" element={<DonorProfile onComplete={() => setCurrentStep('donation')} />} />
                  <Route path="/donation" element={<DonationEntry onComplete={() => setCurrentStep('report')} />} />
                  <Route path="/report" element={<ReportGenerator />} />
                </Routes>
              </div>
            </div>
          </div>
        </div>
      </Router>
    </DonationProvider>
  );
}

export default App;